import { useTranslation } from 'react-i18next'
import { CheckIcon, LoadingDots, Text, Span } from '@/components/atoms'

interface CoverageBannerProps {
  planName: string
  policyId: string
  startDate: string
  className?: string
  isLoading?: boolean
}

export function CoverageBanner({
  planName,
  policyId,
  startDate,
  className = '',
  isLoading = false,
}: CoverageBannerProps) {
  const { t } = useTranslation()
  return (
    <div
      className={`flex w-full flex-col gap-2 overflow-hidden rounded-2xl border border-indigo-100 bg-indigo-50 px-6 py-4 ${className}`}
    >
      {/* Plan name row */}
      <div className="flex items-start justify-start gap-2">
        <div className="bg-indigo-base mt-1 flex size-4 shrink-0 items-center justify-center rounded-full">
          <CheckIcon className="size-3 text-white" />
        </div>
        <Text className="font-bold">
          {isLoading ? <LoadingDots /> : planName}
        </Text>
      </div>

      {/* Policy ID + start date row */}
      <div className="flex items-center gap-2 pl-6">
        <Text>{isLoading ? <LoadingDots /> : policyId}</Text>
        <div className="w-px self-stretch bg-indigo-100" />
        <Span>
          {t('common.startsOn')} {isLoading ? <LoadingDots /> : startDate}
        </Span>
      </div>
    </div>
  )
}
